/* eslint-disable eqeqeq */
import moment from 'moment';
import React from 'react';
import { toast } from 'react-toastify';
import { container } from 'tsyringe';
import { JenisPelatihanPresenter } from '../../../../../../data/presenters/JenisPelatihanPresenter';
import { MenuJenisPelatihanPresenter } from '../../../../../../data/presenters/MenuJenisPelatihanPresenter';
import { PelatihanPresenter } from '../../../../../../data/presenters/PelatihanPresenter';
import { JenisPelatihan } from '../../../../../../entities/JenisPelatihan';
import { SubMenuJenisPelatihan } from '../../../../../../entities/MenuJenisPelatihan';
import { Pelatihan } from '../../../../../../entities/Pelatihan';
import history from '../../../../../../history';
import axiosInstance from '../../../../../api/axiosInstance';
import {
  CACHE_KEYS,
  CACHE_TTL,
  getCache,
  setCache,
} from '../../../../../misc/CacheStorage';
import { mergeOptionsWithSelected } from '../../../../../misc/MergeOptions';
import { OptionMultiSelect } from '../create';

type OptionType = {
  value: string;
  label: string;
};
interface IState {
  isLoading: boolean;
  path_thumbnail: any;
  jenis_pelatihan_id: number;
  sub_menu_jenis_pelatihan_id: number;
  waktu_mulai: string;
  waktu_selesai: string;
  waktu_mulai_pendaftaran: string;
  waktu_selesai_pendaftaran: string;
  penyelenggara: string;
  informasi_umum: string;
  kompetensi_teknis: string;
  persyaratan: string;
  angkatan: string;
  pelatihan: Pelatihan | null;
  jenisPelatihan: JenisPelatihan[];
  subMenuJenisPelatihan: SubMenuJenisPelatihan[];
  status_publish: boolean;
  isPPKB: boolean;
  materiInti: string;
  isForGuruMadrasah: boolean;
  isForPesantren: boolean;
  tidakAdaPenilaian: boolean;
  listOptionsJenisPenilaian: OptionType[];
  jenisPenilaianSelected: OptionType | null;
  jenisPenilaianId: string;
  listAdminNonLembaga: OptionType[];
  adminNonLembagaSelected: OptionType[];
  setAdminNonLembaga: OptionType[];
  accessAdminNonLembaga: boolean;
  linkEvaluasi: string;
  accessLinkEvaluasi: boolean;
  logoPenyelenggara: any;
  statusTtePelatihan: boolean;
  loadingRemoveLogo: boolean;
  isPelatihanSerial: boolean;
  jenisPrasyarat: 'jabatan' | 'pelatihan_relevan';
  listJabatan: OptionType[];
  jabatanSelected: OptionMultiSelect[];
  listPelatihanRelevan: OptionType[];
  pelatihanRelevanSelected: OptionType | null;
}

interface InitialState {
  state: IState;
  updatePelatihan: Function;
  setPathThumbnail: Function;
  setJenisPelatihanId: Function;
  setSubMenuJenisPelatihanId: Function;
  setWaktuMulai: Function;
  setWaktuSelesai: Function;
  setWaktuMulaiPendaftaran: Function;
  setWaktuSelesaiPendaftaran: Function;
  setPenyelenggara: Function;
  setInformasiUmum: Function;
  setKompetensiTeknis: Function;
  setPersyaratan: Function;
  setAngkatan: Function;
  getDetailPelatihan: Function;
  getJenisPelatihan: Function;
  getSubMenuJenisPelatihan: Function;
  setIsPPKB: Function;
  setUpdateManajemenPelatihan: Function;
  getJenisPenilaian: Function;
  setJenisPenilaian: Function;
  getListAdminNonLembaga: Function;
  setAdminNonLembaga: Function;
  setLinkEvaluasi: Function;
  setAccessLinkEvaluasi: Function;
  setLogoPenyelenggara: Function;
  removeLogoPenyelenggara: Function;
  setLoadingRemoveLogo: Function;
  setIsPelatihanSerial: Function;
  setJenisPrasyarat: Function;
  getListJabatan: Function;
  setJabatanSelected: Function;
  getListPelatihanRelevan: Function;
  setPelatihanRelevanSelected: Function;
}

const initialState: InitialState = {
  state: {
    isLoading: false,
    path_thumbnail: null,
    jenis_pelatihan_id: 0,
    sub_menu_jenis_pelatihan_id: 0,
    waktu_mulai: '',
    waktu_selesai: '',
    waktu_mulai_pendaftaran: '',
    waktu_selesai_pendaftaran: '',
    penyelenggara: '',
    informasi_umum: '',
    kompetensi_teknis: '',
    persyaratan: '',
    angkatan: '',
    pelatihan: null,
    jenisPelatihan: [],
    subMenuJenisPelatihan: [],
    status_publish: false,
    isPPKB: false,
    materiInti: '',
    isForGuruMadrasah: false,
    isForPesantren: false,
    tidakAdaPenilaian: false,
    listOptionsJenisPenilaian: [],
    jenisPenilaianSelected: null,
    jenisPenilaianId: '',
    listAdminNonLembaga: [],
    adminNonLembagaSelected: [],
    setAdminNonLembaga: [],
    accessAdminNonLembaga: false,
    linkEvaluasi: '',
    accessLinkEvaluasi: false,
    logoPenyelenggara: null,
    statusTtePelatihan: false,
    loadingRemoveLogo: false,
    isPelatihanSerial: false,
    jenisPrasyarat: 'jabatan',
    listJabatan: [],
    jabatanSelected: [],
    listPelatihanRelevan: [],
    pelatihanRelevanSelected: null,
  },
  updatePelatihan: () => {},
  setPathThumbnail: () => {},
  setJenisPelatihanId: () => {},
  setSubMenuJenisPelatihanId: () => {},
  setWaktuMulai: () => {},
  setWaktuSelesai: () => {},
  setWaktuMulaiPendaftaran: () => {},
  setWaktuSelesaiPendaftaran: () => {},
  setPenyelenggara: () => {},
  setInformasiUmum: () => {},
  setKompetensiTeknis: () => {},
  setPersyaratan: () => {},
  setAngkatan: () => {},
  getDetailPelatihan: () => {},
  getJenisPelatihan: () => {},
  getSubMenuJenisPelatihan: () => {},
  setIsPPKB: () => {},
  setUpdateManajemenPelatihan: () => {},
  getJenisPenilaian: () => {},
  setJenisPenilaian: () => {},
  getListAdminNonLembaga: () => {},
  setAdminNonLembaga: () => {},
  setLinkEvaluasi: () => {},
  setAccessLinkEvaluasi: () => {},
  setLogoPenyelenggara: () => {},
  removeLogoPenyelenggara: () => {},
  setLoadingRemoveLogo: () => {},
  setIsPelatihanSerial: () => {},
  setJenisPrasyarat: () => {},
  getListJabatan: () => {},
  setJabatanSelected: () => {},
  getListPelatihanRelevan: () => {},
  setPelatihanRelevanSelected: () => {},
};
const Context = React.createContext<InitialState>(initialState);
const { Provider: ManajemenPelatihanUpdateProvider } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = React.useState<IState>({
    isLoading: false,
    path_thumbnail: null,
    jenis_pelatihan_id: 0,
    sub_menu_jenis_pelatihan_id: 0,
    waktu_mulai: '',
    waktu_selesai: '',
    waktu_mulai_pendaftaran: '',
    waktu_selesai_pendaftaran: '',
    penyelenggara: '',
    informasi_umum: '',
    kompetensi_teknis: '',
    persyaratan: '',
    angkatan: '',
    pelatihan: null,
    jenisPelatihan: [],
    subMenuJenisPelatihan: [],
    status_publish: false,
    isPPKB: false,
    materiInti: '',
    isForGuruMadrasah: false,
    isForPesantren: false,
    tidakAdaPenilaian: false,
    listOptionsJenisPenilaian: [],
    jenisPenilaianSelected: null,
    jenisPenilaianId: '',
    listAdminNonLembaga: [],
    adminNonLembagaSelected: [],
    setAdminNonLembaga: [],
    accessAdminNonLembaga: false,
    linkEvaluasi: '',
    accessLinkEvaluasi: false,
    logoPenyelenggara: null,
    statusTtePelatihan: false,
    loadingRemoveLogo: false,
    isPelatihanSerial: false,
    jenisPrasyarat: 'jabatan',
    listJabatan: [],
    jabatanSelected: [],
    listPelatihanRelevan: [],
    pelatihanRelevanSelected: null,
  });

  const setUpdateManajemenPelatihan = <K extends keyof IState>(
    key: K,
    value: IState[K]
  ) => {
    setState((prevstate) => ({
      ...prevstate,
      [key]: value,
    }));

    if (key == 'accessAdminNonLembaga' && value === false) {
      setState((prevstate) => ({
        ...prevstate,
        adminNonLembagaSelected: [],
      }));
    }
  };

  const setLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoading: value,
    }));
  };

  const updatePelatihan = async (id: number) => {
    setLoading(true);

    if (
      state.jenis_pelatihan_id == 0 ||
      state.sub_menu_jenis_pelatihan_id == 0 ||
      state.waktu_mulai == '' ||
      state.waktu_selesai == '' ||
      state.waktu_mulai_pendaftaran == '' ||
      state.waktu_selesai_pendaftaran == '' ||
      state.penyelenggara == '' ||
      state.informasi_umum == '' ||
      state.persyaratan == '' ||
      state.angkatan == '' ||
      (state.accessAdminNonLembaga &&
        state.adminNonLembagaSelected.length == 0) ||
      (state.accessLinkEvaluasi && state.linkEvaluasi == '') ||
      (state.isPelatihanSerial &&
        state.jenisPrasyarat === 'jabatan' &&
        state.jabatanSelected.length == 0) ||
      (state.isPelatihanSerial &&
        state.jenisPrasyarat === 'pelatihan_relevan' &&
        state.pelatihanRelevanSelected === null)
    ) {
      toast('Data Belum Terisi Lengkap!');
      setLoading(false);
      return;
    }

    try {
      const pelatihanPresenter = container.resolve(PelatihanPresenter);

      const pelatihanRelevanValue =
        state.isPelatihanSerial && state.jenisPrasyarat === 'pelatihan_relevan'
          ? state.pelatihanRelevanSelected?.value ?? ''
          : '';

      const jabatanValue =
        state.isPelatihanSerial && state.jenisPrasyarat === 'jabatan'
          ? state.jabatanSelected
          : [];

      const update = await pelatihanPresenter.updatePelatihan(
        state.pelatihan?.id as number,
        state.path_thumbnail,
        state.sub_menu_jenis_pelatihan_id,
        state.jenis_pelatihan_id,
        moment(state.waktu_mulai).format('YYYY-MM-DD HH:mm:ss'),
        moment(state.waktu_selesai).format('YYYY-MM-DD HH:mm:ss'),
        moment(state.waktu_mulai_pendaftaran).format('YYYY-MM-DD HH:mm:ss'),
        moment(state.waktu_selesai_pendaftaran).format('YYYY-MM-DD HH:mm:ss'),
        state.penyelenggara,
        state.informasi_umum,
        state.kompetensi_teknis,
        state.persyaratan,
        state.angkatan,
        state.status_publish,
        state.isPPKB,
        state.isPPKB ? state.materiInti : '',
        state.isForGuruMadrasah,
        state.isForPesantren,
        state.tidakAdaPenilaian,
        state.jenisPenilaianSelected?.value as string,
        state.adminNonLembagaSelected,
        state.linkEvaluasi,
        state.logoPenyelenggara,
        pelatihanRelevanValue,
        jabatanValue
      );

      const data = update;

      if (data.data.code == 200) {
        toast('Berhasil Ubah Data .');

        history.replace(
          `/admin/kelola_konten/manajemen_pelatihan/${data.data.data.uuid}`
        );
        window.location.reload();
      } else {
        toast('Ada Kesalahan Saat Ubah Data!');
      }
      setLoading(false);
    } catch (error: any) {
      console.error('error pelatihan:', error);
      toast('Ada Kesalahan Saat Ubah Data!');
      setLoading(false);
    }
  };

  const setPathThumbnail = (value) => {
    setState((prevstate) => ({
      ...prevstate,
      path_thumbnail: value,
    }));
  };

  const setJenisPelatihanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      jenis_pelatihan_id: value,
    }));
  };

  const setSubMenuJenisPelatihanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      sub_menu_jenis_pelatihan_id: value,
    }));
  };

  const setWaktuMulai = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_mulai: value,
    }));
  };

  const setWaktuSelesai = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_selesai: value,
    }));
  };

  const setWaktuMulaiPendaftaran = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_mulai_pendaftaran: value,
    }));
  };

  const setWaktuSelesaiPendaftaran = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_selesai_pendaftaran: value,
    }));
  };

  const setPenyelenggara = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      penyelenggara: value,
    }));
  };

  const setInformasiUmum = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      informasi_umum: value,
    }));
  };

  const setKompetensiTeknis = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      kompetensi_teknis: value,
    }));
  };

  const setPersyaratan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      persyaratan: value,
    }));
  };

  const setAngkatan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      angkatan: value,
    }));
  };

  const setIsPPKB = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isPPKB: value,
    }));
  };

  const getDetailPelatihan = async (id: number) => {
    try {
      const pelatihanPresenter = container.resolve(PelatihanPresenter);
      const getDetail = await pelatihanPresenter.getDetailPelatihan(id);

      const data = getDetail;

      const listAkunAdmin = data.selected_user_monitoring.map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });

      const selectedJabatan = data.prasyarat_pelatihan_jabatan.map((item) => {
        return {
          value: item.level_jabatan,
          label: item.level_jabatan,
        };
      });

      const listPelatihanSerial = {
        value: data?.prasyarat_pelatihan_relevan?.id,
        label: data?.prasyarat_pelatihan_relevan?.judul_pelatihan,
      } as unknown as OptionType;

      setAdminNonLembaga(listAkunAdmin as unknown as OptionType[]);

      setState((prevstate) => ({
        ...prevstate,
        pelatihan: data,
        jenis_pelatihan_id: data.jenis_pelatihan_id,
        sub_menu_jenis_pelatihan_id: data.sub_menu_jenis_pelatihan_id,
        waktu_mulai: data.waktu_mulai,
        waktu_selesai: data.waktu_selesai,
        waktu_mulai_pendaftaran: data.waktu_buka_pendaftaran,
        waktu_selesai_pendaftaran: data.waktu_tutup_pendaftaran,
        penyelenggara: data.penyelenggara,
        informasi_umum: data.informasi_umum,
        persyaratan: data.persyaratan,
        angkatan: data.angkatan,
        status_publish: data.status_publish === 1 ? true : false,
        kompetensi_teknis: data.kompetensi_teknis,
        isPPKB: data.is_ppkb === 1 ? true : false,
        materiInti: data.materi_inti,
        path_thumbnail: data.path_thumbnail,
        isForGuruMadrasah: data.is_for_guru_madrasah === 1 ? true : false,
        isForPesantren: data.is_for_pesantren === 1 ? true : false,
        tidakAdaPenilaian: data.tidak_ada_penilaian === 1 ? true : false,
        jenisPenilaianId: data?.jenis_penilaian_id.toString(),
        accessAdminNonLembaga:
          data?.selected_user_monitoring.length > 0 ? true : false,
        accessLinkEvaluasi: data?.link_evaluasi != '' ? true : false,
        linkEvaluasi: data?.link_evaluasi,
        logoPenyelenggara: data?.logo_penyelenggara,
        statusTtePelatihan: data?.status_tte_pelatihan,
        isPelatihanSerial:
          data.has_prasyarat_pelatihan_relevan ||
          data.has_prasyarat_pelatihan_jabatan,
        jenisPrasyarat: data.has_prasyarat_pelatihan_relevan
          ? 'pelatihan_relevan'
          : 'jabatan',
        jabatanSelected: data.has_prasyarat_pelatihan_jabatan
          ? selectedJabatan
          : [],
        pelatihanRelevanSelected: data.has_prasyarat_pelatihan_relevan
          ? listPelatihanSerial
          : null,
      }));

      if (data.has_prasyarat_pelatihan_jabatan) {
        getListJabatan();
      }

      if (data.has_prasyarat_pelatihan_relevan) {
        getListPelatihanRelevan();
      }

      getJenisPelatihan(data.sub_menu_jenis_pelatihan_id.toString());
    } catch (error: any) {
      console.error('error get pelatihan:', error);
      setLoading(false);
    }
  };

  const getJenisPelatihan = async (sub_menu_jenis_pelatihan_id: string) => {
    try {
      const jenisPelatihan = container.resolve(JenisPelatihanPresenter);

      const get = await jenisPelatihan.getAllJenisPelatihan(
        1,
        10000000,
        '',
        sub_menu_jenis_pelatihan_id
      );

      const data = get;

      setState((prevstate) => ({
        ...prevstate,
        jenisPelatihan: data,
      }));
    } catch (error: any) {
      console.error('error get Jenis Pelatihan:', error);
    }
  };

  const getSubMenuJenisPelatihan = async () => {
    try {
      const menuJenisPelatihanPresenter = container.resolve(
        MenuJenisPelatihanPresenter
      );

      const get = await menuJenisPelatihanPresenter.getAllSubMenuJenisPelatihan(
        1,
        10000000,
        ''
      );

      const data = get;

      setState((prevstate) => ({
        ...prevstate,
        subMenuJenisPelatihan: data,
      }));
    } catch (error: any) {
      console.error('error get Sub Menu Jenis Pelatihan:', error);
    }
  };

  const setJenisPenilaian = (value: OptionType) => {
    setState((prevstate) => ({
      ...prevstate,
      jenisPenilaianSelected: value,
    }));
  };

  const getJenisPenilaian = async () => {
    try {
      const { data } = await axiosInstance.get('jenis_penilaian');
      const listJenisPenialain = data?.data.map((item) => {
        return {
          value: item.id,
          label: item.nama_jenis_penilaian,
        };
      });

      setState((prevstate) => ({
        ...prevstate,
        listOptionsJenisPenilaian: listJenisPenialain,
      }));
    } catch (error) {
      throw error;
    }
  };

  const getListAdminNonLembaga = async () => {
    try {
      const pelatihan = container.resolve(PelatihanPresenter);

      const get = await pelatihan.getAdminNonlembaga();

      const data = get;

      const listAdminNonLembaga = data?.map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });

      setState((prevstate) => ({
        ...prevstate,
        listAdminNonLembaga: listAdminNonLembaga,
      }));
    } catch (error: any) {
      console.error('error get admin non lembaga:', error);
    }
  };

  const setAdminNonLembaga = (value: OptionType[]) => {
    setState((prevstate) => ({
      ...prevstate,
      adminNonLembagaSelected: value,
    }));
  };

  const setLinkEvaluasi = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      linkEvaluasi: value,
    }));
  };

  const setAccessLinkEvaluasi = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      accessLinkEvaluasi: value,
    }));

    if (!value) {
      setState((prevstate) => ({
        ...prevstate,
        linkEvaluasi: '',
      }));
    }
  };

  const setLogoPenyelenggara = (value) => {
    setState((prevstate) => ({
      ...prevstate,
      logoPenyelenggara: value,
    }));
  };

  const removeLogoPenyelenggara = async () => {
    setLoadingRemoveLogo(true);

    try {
      const pelatihanPresenter = container.resolve(PelatihanPresenter);

      const update = await pelatihanPresenter.removeLogoPenyelenggaraPelatihan(
        state.pelatihan?.id as number
      );

      const data = update;

      if (data.data.code == 200) {
        toast('Berhasil Hapus Logo Penyelenggara.');
        setLogoPenyelenggara(null);
      } else {
        toast('Ada Kesalahan Saat Hapus Logo Penyelenggara!');
      }
      setLoadingRemoveLogo(false);
    } catch (error: any) {
      console.error('error pelatihan:', error);
      toast('Ada Kesalahan Saat Hapus Logo Penyelenggara!');
      setLoadingRemoveLogo(false);
    }
  };

  const setLoadingRemoveLogo = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      loadingRemoveLogo: value,
    }));
  };

  const setIsPelatihanSerial = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isPelatihanSerial: value,
    }));
  };

  const setJenisPrasyarat = (value: 'jabatan' | 'pelatihan_relevan') => {
    setState((prevstate) => ({
      ...prevstate,
      jenisPrasyarat: value,
    }));
  };

  const getListJabatan = async (forceRefresh: boolean = false) => {
    try {
      if (!forceRefresh) {
        const cachedData = getCache<OptionType[]>(CACHE_KEYS.LIST_JABATAN);
        if (cachedData) {
          setState((prevstate) => {
            const mergedList = mergeOptionsWithSelected(
              cachedData,
              prevstate.jabatanSelected
            );

            return {
              ...prevstate,
              listJabatan: mergedList as OptionType[],
            };
          });
          return;
        }
      }

      const { data } = await axiosInstance.get('simdiklat/master_data/jabatan');

      const listJabatanMapping = data?.data.map((item) => {
        return {
          value: item.nama,
          label: item.nama,
        };
      });

      setCache(
        CACHE_KEYS.LIST_JABATAN,
        listJabatanMapping,
        CACHE_TTL.MASTER_DATA
      );

      setState((prevstate) => {
        const mergedList = mergeOptionsWithSelected(
          listJabatanMapping,
          prevstate.jabatanSelected
        );

        return {
          ...prevstate,
          listJabatan: mergedList as OptionType[],
        };
      });
    } catch (error) {
      console.error('Error fetching list jabatan:', error);
      throw error;
    }
  };

  const setJabatanSelected = (value) => {
    setState((prevstate) => ({
      ...prevstate,
      jabatanSelected: value,
    }));
  };

  const getListPelatihanRelevan = async (forceRefresh: boolean = false) => {
    try {
      if (!forceRefresh) {
        const cachedData = getCache<OptionType[]>(
          CACHE_KEYS.LIST_PELATIHAN_RELEVAN
        );
        if (cachedData) {
          setState((prevstate) => ({
            ...prevstate,
            listPelatihanRelevan: cachedData,
          }));
          return;
        }
      }

      const { data } = await axiosInstance.get('pelatihan/relevan/list', {
        params: {
          page: 1,
          rows: 10000000,
        },
      });

      const listPelatihanRelevanMapping = data?.data.map((item) => {
        return {
          value: item.id,
          label: item.judul_pelatihan,
        };
      });

      setCache(
        CACHE_KEYS.LIST_PELATIHAN_RELEVAN,
        listPelatihanRelevanMapping,
        CACHE_TTL.MASTER_DATA
      );

      setState((prevstate) => ({
        ...prevstate,
        listPelatihanRelevan: listPelatihanRelevanMapping,
      }));
    } catch (error) {
      console.error('Error fetching list pelatihan relevan:', error);
      throw error;
    }
  };

  const setPelatihanRelevanSelected = (value: OptionType) => {
    setState((prevstate) => ({
      ...prevstate,
      pelatihanRelevanSelected: value,
    }));
  };

  return (
    <ManajemenPelatihanUpdateProvider
      value={{
        state,
        updatePelatihan,
        setPathThumbnail,
        setJenisPelatihanId,
        setSubMenuJenisPelatihanId,
        setWaktuMulai,
        setWaktuSelesai,
        setWaktuMulaiPendaftaran,
        setWaktuSelesaiPendaftaran,
        setPenyelenggara,
        setInformasiUmum,
        setKompetensiTeknis,
        setPersyaratan,
        setAngkatan,
        getDetailPelatihan,
        getJenisPelatihan,
        getSubMenuJenisPelatihan,
        setIsPPKB,
        setUpdateManajemenPelatihan,
        getJenisPenilaian,
        setJenisPenilaian,
        getListAdminNonLembaga,
        setAdminNonLembaga,
        setLinkEvaluasi,
        setAccessLinkEvaluasi,
        setLogoPenyelenggara,
        removeLogoPenyelenggara,
        setLoadingRemoveLogo,
        setIsPelatihanSerial,
        setJenisPrasyarat,
        getListJabatan,
        setJabatanSelected,
        getListPelatihanRelevan,
        setPelatihanRelevanSelected,
      }}
    >
      {children}
    </ManajemenPelatihanUpdateProvider>
  );
};

export const useManajemenPelatihanUpdateContext = () =>
  React.useContext(Context);
// eslint-disable-next-line
export default {
  useManajemenPelatihanUpdateContext,
  Provider,
};
